import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { tap } from "rxjs";
import { NotificationMessageService } from "../../services/notification.message.service";
import { GLOBAL_HTTP_ERRORS } from "./error.constants";

export const globalErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const messages = inject(NotificationMessageService);
  const translateService = inject(TranslateService);

  return next(request).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if (error.status === 0) {
          messages.showErrorMessage(translateService.instant("NO_AVAILABLE_RESPONSE"));
          return;
        }

        const translationKey = GLOBAL_HTTP_ERRORS.get(error.status);
        if (translationKey) {
          messages.showErrorMessage(translateService.instant(translationKey));
        }
      },
    }),
  );
};
